import mapWpPosts from '@/utils/functions/wordpress/mapWpPosts';
import wpApi from '@/utils/functions/wordpress/wpApi';
import type { Event } from '@/types/ArticleType';

const fetchEvents = async (limit = 12, onlyUpcoming = true): Promise<Event[]> => {
    const api = wpApi();

    api.events = api.registerRoute('wp/v2', '/events/(?P<id>\\d+)');
    const events = await api.events().perPage(limit).orderby('date').order('desc').embed();

    return mapWpPosts(onlyUpcoming ? events.filter((w: any) => new Date(w.acf?.date_and_time) > new Date()) : events)
        .filter(event => event.customFields.is_master_event)
        .map((event: any) => {
            const eventStartDate = new Date(event.customFields.date_and_time || '');
            const eventEndDate = new Date(event.customFields.date_and_time_end || '');

            return {
                ...event,
                eventStartDate: eventStartDate.getTime() / 1000,
                eventEndDate: eventEndDate.getTime() / 1000,
            };
        }) as Event[];
};

export default fetchEvents;
